const cache = new Map();
const inflight = new Map();

export function getRouteCache(key) {
  if (!key) return undefined;
  return cache.get(key);
}

export function setRouteCache(key, value) {
  if (!key) return;
  cache.set(key, value);
}

export function hasRouteCache(key) {
  return key ? cache.has(key) : false;
}

export function deleteRouteCache(key) {
  if (key) cache.delete(key);
}

export function forEachRouteCacheKey(prefix, fn) {
  if (!prefix || typeof fn !== "function") return;
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) {
      fn(key, cache.get(key));
    }
  }
}

export function clearRouteCache() {
  cache.clear();
}

/** Dedupe concurrent fetches for the same cache key. */
export async function fetchRouteCache(key, fetchFn) {
  if (!key) {
    return fetchFn();
  }

  if (cache.has(key)) {
    return cache.get(key);
  }

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = Promise.resolve()
    .then(fetchFn)
    .then((value) => {
      cache.set(key, value);
      inflight.delete(key);
      return value;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, promise);
  return promise;
}
